import { 
    apiRequest,
    strukturOrganisasiPeriodList 
} from "../../../../../services/adapters/base"

class IndexRepository {
    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", strukturOrganisasiPeriodList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default IndexRepository
